import type { RadiosJSONSchema } from "../../../../types";
import { useEffect } from "react";
import Selections from "../selections";
import styles from "./styles.module.scss";
import { useBlockType } from "../../contexts/BlockTypeContext";

const MAX_OPTIONS_COUNT = 10;
const VARIANT = "radio";

type Props = {
  jsonSchema: RadiosJSONSchema;
  // edit mode
  onChangeJsonSchema: (arg: RadiosJSONSchema) => void;
  gptBusy?: boolean;
};

const Radios = ({ jsonSchema, onChangeJsonSchema, gptBusy }: Props) => {
  const { onChange, value } = useBlockType();

  // sanity check
  useEffect(() => {
    if (!jsonSchema?.enum) {
      return onChangeJsonSchema({
        ...jsonSchema,
        enum: [],
      });
    }
  }, [jsonSchema, onChangeJsonSchema]);

  return (
    <Selections
      {...{ onChange, value }}
      className={styles["radios"]}
      options={jsonSchema?.enum}
      onChangeOptions={(v) =>
        onChangeJsonSchema({
          ...jsonSchema,
          enum: v,
        })
      }
      type={VARIANT}
      count={MAX_OPTIONS_COUNT}
      disabled={gptBusy}
    />
  );
};

export default Radios;
